(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[595],{

/***/ 9655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ArticleCoverImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const ArticleCoverImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)((param)=>{
    let { cover  } = param;
    const { src , width , height  } = cover.img;
    const ratio = width / height;
    const isLayoutFill = ratio < GOLDEN_RATIO;
    const layoutProps = isLayoutFill ? {
        layout: "fill",
        objectFit: "cover",
        objectPosition: "center center"
    } : {
        layout: "responsive",
        width,
        height
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `text-[length:0] relative ${isLayoutFill ? "min-h-[50vw] md:min-h-[350px]" : ""}
      shadow-lg -mx-6 mt-4 lg:mb-4 mb-2 lg:mt-8 rounded-lg overflow-hidden`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src,
                itemProp: "image",
                itemScope: true,
                itemType: "http://schema.org/ImageObject",
                alt: "",
                ...layoutProps,
                placeholder: cover.blurDataURL ? "blur" : "empty",
                blurDataURL: cover.blurDataURL ?? undefined,
                ...cover.preload ? {
                    loading: "eager",
                    priority: true
                } : {
                    loading: "lazy",
                    priority: false
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "width",
                content: String(cover.img.width)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "height",
                content: String(cover.img.height)
            })
        ]
    });
});
ArticleCoverImage.displayName = "ArticleCoverImage";


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ArticleTitle; },
/* harmony export */   "r": function() { return /* binding */ wisząceSpójniki; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _SectionTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3895);




const NBSP = "\xa0";
const wisząceSpójniki = (title)=>title.replace(/((\s(\p{L})|(\b[0-9]{1,3}))\s)/gu, `$2${NBSP}`);
const ArticleTitle = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)((param)=>{
    let { title , href , level  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        className: "inline-block",
        itemProp: "mainEntityOfPage",
        rel: "bookmark",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionTitle__WEBPACK_IMPORTED_MODULE_3__/* .SectionTitle */ .N, {
            size: "large",
            level: level,
            itemProp: "headline",
            children: wisząceSpójniki(title)
        })
    });
});
ArticleTitle.displayName = "ArticleTitle";


/***/ }),

/***/ 4207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const Button = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        ...props,
        className: `block mt-1 bg-green-700 text-gray-100 text-2xl rounded-md py-2 focus:ring focus:bg-green-600 focus:ring-blue-100 focus:ring-offset-2 focus:ring-opacity-50 outline-none transition-all ${props.className ?? ""}`
    });
};


/***/ }),

/***/ 2544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "w-full font-sans text-sm",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: ref,
                ...props,
                className: `block mt-1 w-full py-[0.3rem] focus:border-blue-200 border-gray-300 rounded-md shadow-sm transition-shadow focus:ring-offset-2 focus:ring focus:ring-blue-100 focus:ring-opacity-50 ${props.className ?? ""}`
            })
        ]
    });
});
Input.displayName = "Input";


/***/ }),

/***/ 3895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const SectionTitle = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)((param)=>{
    let { children , itemProp , level , size ="large"  } = param;
    const textSize = size === "large" ? "text-3xl lg:text-5xl font-semibold" : size === "medium" ? "text-2xl lg:text-4xl font-semibold" : size === "small" ? "text-2xl lg:text-3xl font-semibold" : "text-xl lg:text-2xl";
    const El = level === "none" ? "span" : `h${level}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(El, {
        className: `block text-gray-900 font-sans hover:text-gray-700 transition-colors ${textSize} leading-none`,
        itemProp: itemProp,
        children: children
    });
});
SectionTitle.displayName = "SectionTitle";


/***/ }),

/***/ 1244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ArticleMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polish_plurals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2083);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _utils_categories__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(731);
/* harmony import */ var _utils_series__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2475);
/* harmony import */ var _atoms_LinkUnderlineEffect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);








const S = 32;
const L = 48;
const komentarzy = polish_plurals__WEBPACK_IMPORTED_MODULE_7__/* .polishPlurals.bind */ .K.bind(null, "komentarz", "komentarze", "komentarzy");
const ArticleMeta = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)((param)=>{
    let { authors , mainCategory , rel , series , permalink , commentsCount , size ="small"  } = param;
    const isSmall = size === "small";
    const href = "/" + permalink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            series && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "mb-4 mt-3 text-center text-lg",
                children: [
                    "Ten artykuł jest częścią",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                        children: [
                            series.currentIndex + 1,
                            " z ",
                            series.count
                        ]
                    }),
                    " ",
                    "w serii",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_LinkUnderlineEffect__WEBPACK_IMPORTED_MODULE_6__/* .LinkUnderlineEffect */ .t, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: (0,_utils_series__WEBPACK_IMPORTED_MODULE_5__/* .getSeriesLink */ .CX)(series),
                            className: "text-blue-500",
                            children: series.name
                        })
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-shrink-0 items-center mr-2",
                            children: authors.map((author, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `inline-flex border-2 rounded-full border-gray-100  ${isSmall ? "-mr-4 last:mr-0" : "-mr-6 last:mr-2"}`,
                                    style: {
                                        zIndex: authors.length - idx
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: author.avatarUrl + (isSmall ? `?s=${S * 2}` : `?s=${L * 2}`),
                                        width: isSmall ? S : L,
                                        height: isSmall ? S : L,
                                        layout: "fixed",
                                        alt: `Zdjęcie ${author.displayName}`,
                                        className: `rounded-full`,
                                        unoptimized: true
                                    })
                                }, author.slug))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "font-sans text-sm font-semibold leading-tight sm:text-base",
                            children: [
                                authors.map((author, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                itemScope: true,
                                                itemType: "http://schema.org/Person",
                                                itemProp: "author",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: `text-gray-800 ${isSmall ? "text-base" : "text-lg"}`,
                                                    itemProp: "name",
                                                    children: author.displayName
                                                })
                                            }),
                                            idx === authors.length - 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: `text-gray-800 font-normal ${isSmall ? "text-base" : "text-lg"}`,
                                                children: " i\xa0"
                                            }) : idx === authors.length - 1 ? "" : ", "
                                        ]
                                    }, author.slug)),
                                mainCategory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `before:content-['·'] before:mx-2 text-blue-500 font-medium before:text-gray-900 whitespace-nowrap block sm:inline ${isSmall ? "text-base" : "text-lg"}`,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: (0,_utils_categories__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryLink */ .Od)(mainCategory),
                                        ...rel && {
                                            rel: "category tag"
                                        },
                                        children: mainCategory.name
                                    })
                                }),
                                typeof commentsCount === "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `before:content-['·'] before:mx-2 text-blue-500 font-medium before:text-gray-900 whitespace-nowrap block sm:inline ${isSmall ? "text-base" : "text-lg"}`,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: href + "#comments",
                                        children: [
                                            commentsCount || "Brak",
                                            " ",
                                            komentarzy(commentsCount)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
ArticleMeta.displayName = "ArticleMeta";


/***/ }),

/***/ 8958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NewsletterForm": function() { return /* binding */ NewsletterForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/atoms/Button.tsx
var Button = __webpack_require__(4207);
// EXTERNAL MODULE: ./components/atoms/Card.tsx
var Card = __webpack_require__(2409);
;// CONCATENATED MODULE: ./components/atoms/Checkbox.tsx

const Checkbox = (param)=>{
    let { children , label , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: `flex flex-row gap-4 items-center w-full font-sans text-sm`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ...props,
                type: "checkbox",
                className: `block mt-1 w-6 h-6 text-green-700 focus:border-blue-200 border-gray-300 rounded-md shadow-sm transition-shadow focus:ring-offset-2 focus:ring focus:ring-blue-100 focus:ring-opacity-50 ${props.className ?? ""}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: label === "tiny" ? "font-serif text-gray-700 text-tiny font-normal" : "",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/Input.tsx
var Input = __webpack_require__(2544);
// EXTERNAL MODULE: ./components/atoms/LinkUnderlineEffect.tsx
var LinkUnderlineEffect = __webpack_require__(8683);
// EXTERNAL MODULE: ./components/atoms/SectionTitle.tsx
var SectionTitle = __webpack_require__(3895);
;// CONCATENATED MODULE: ./components/molecules/NewsletterForm.tsx










const NewsletterForm = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { utmSource  } = param;
    const [state, setState] = (0,react.useState)("IDLE");
    const [name, setName] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const r = (0,router.useRouter)();
    const utmSourceValue = encodeURIComponent(utmSource || r.asPath.split(/[#?]/g).shift()?.slice(1) || "front-page");
    const handleSubmit = (0,react.useCallback)(async (e)=>{
        e.preventDefault();
        setState("SENDING");
        try {
            const payload = {
                name,
                email,
                emailType: "subscribe",
                labels: [
                    "typeofweb.com"
                ],
                requestSrc: "typeofweb.com"
            };
            await fetch("https://news.typeofweb.com/members/api/send-magic-link/", {
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify(payload),
                method: "POST"
            });
            setState("SUCCESS");
        } catch (err) {
            setState("ERROR");
        }
    }, [
        email,
        name
    ]);
    (0,react.useEffect)(()=>{
        if (state === "ERROR" || state === "SUCCESS") {
            const timerId = setTimeout(()=>setState("IDLE"), 5000);
            return ()=>clearTimeout(timerId);
        }
    }, [
        state
    ]);
    const handleNameInput = (0,react.useCallback)((e)=>{
        setName(e.currentTarget.value);
    }, []);
    const handleEmailInput = (0,react.useCallback)((e)=>{
        setEmail(e.currentTarget.value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        as: "section",
        className: "newsletter-form mb-12 mx-auto pt-4 max-w-xl border shadow-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-4 px-5 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle/* SectionTitle */.N, {
                        level: "none",
                        size: "small",
                        children: [
                            "Zapisz się na newsletter ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "„Polski frontend i backend”"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        level: "none",
                        size: "xs",
                        children: "aby otrzymywać najciekawsze linki do materiał\xf3w i\xa0wydarzeń wybranych przeze mnie!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://news.typeofweb.com/?utm_medium=Blog&utm_source=typeofweb.com&utm_campaign=${utmSourceValue}`,
                                target: "_blank",
                                className: "text-blue-500",
                                rel: "noreferrer",
                                children: "news.typeofweb.com"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit,
                action: "https://news.typeofweb.com/members/api/send-magic-link/",
                method: "post",
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-4 px-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                type: "text",
                                name: "name",
                                value: name,
                                onInput: handleNameInput,
                                children: "Imię i nazwisko"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                type: "email",
                                required: true,
                                name: "email",
                                value: email,
                                onInput: handleEmailInput,
                                children: "Email"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox, {
                                label: "tiny",
                                required: true,
                                children: [
                                    "Rozumiem i akceptuję",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/regulamin",
                                        target: "_blank",
                                        className: "text-blue-500 hover:underline font-normal",
                                        children: "Regulamin Newslettera"
                                    }),
                                    " ",
                                    "oraz",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/polityka-prywatnosci",
                                        target: "_blank",
                                        className: "text-blue-500 hover:underline font-normal",
                                        children: "Politykę Prywatności"
                                    }),
                                    ". Wyrażam zgodę na otrzymywanie na podany adres e-mail informacji handlowych w rozumieniu ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            disabled: state !== "IDLE",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-8",
                                children: [
                                    (state === "SENDING" || state === "SUCCESS" || state === "ERROR") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: `w-5 h-5 text-white transition-all inline-block ${state === "SENDING" ? "animate-spin mx-auto" : "mr-2 -ml-1"}`,
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            state === "SENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: state === "SENDING" ? `opacity-75` : `opacity-100`,
                                                fill: "currentColor",
                                                ...state === "SENDING" && {
                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                },
                                                ...state === "SUCCESS" && {
                                                    d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                                                },
                                                ...state === "ERROR" && {
                                                    d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
                                                }
                                            })
                                        ]
                                    }),
                                    state === "IDLE" && "Zapisz się",
                                    state === "SUCCESS" && "Udało się! Sprawdź maila :)",
                                    state === "ERROR" && "Coś poszło nie tak :("
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
});
NewsletterForm.displayName = "NewsletterForm";


/***/ }),

/***/ 7686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ TwoColumns; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./hooks/useUiState.tsx
var useUiState = __webpack_require__(8654);
// EXTERNAL MODULE: ./components/molecules/SiteHeader.tsx + 3 modules
var SiteHeader = __webpack_require__(4082);
// EXTERNAL MODULE: ./components/organisms/AppFooter.tsx + 7 modules
var AppFooter = __webpack_require__(8578);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/series.ts
var utils_series = __webpack_require__(2475);
// EXTERNAL MODULE: ./components/atoms/LinkUnderlineEffect.tsx
var LinkUnderlineEffect = __webpack_require__(8683);
// EXTERNAL MODULE: ./components/atoms/Widget.tsx
var Widget = __webpack_require__(4453);
;// CONCATENATED MODULE: ./components/molecules/LatestPostsWidget.tsx






const selectedSeries = [
    {
        title: "Kurs React.js od podstaw",
        slug: (0,utils_series/* getSeriesLink */.CX)("react-js")
    },
    {
        title: "Studia w pigułce",
        slug: (0,utils_series/* getSeriesLink */.CX)("piece-of-cake")
    },
    {
        title: "Self Publishing „TypeScript na poważnie”",
        slug: (0,utils_series/* getSeriesLink */.CX)("self-publishing")
    },
    {
        title: "Kurs CI/CD z Buddy.works",
        slug: (0,utils_series/* getSeriesLink */.CX)("buddy-works")
    }
];
const LatestPostsWidget = /*#__PURE__*/ (0,react.memo)(()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* Widget */.$, {
        title: "Najpopularniejsze wpisy:",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "counter-reset pl-6",
            children: selectedSeries.map((series)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "counter-increment before:counter-result before:text-stroke before:absolute relative before:top-0 before:-ml-8 mb-6 before:mr-2 before:text-gray-500 before:font-sans before:text-4xl before:proportional-nums before:font-semibold before:leading-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: series.slug,
                            className: "align-top hover:text-blue-500 text-gray-700 text-lg leading-snug transition-all",
                            children: series.title
                        })
                    })
                }, series.slug);
            })
        })
    });
});
LatestPostsWidget.displayName = "LatestPostsWidget";

;// CONCATENATED MODULE: ./images/social/book.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgBook = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12 6.3v13m0-13C10.8 5.5 9.2 5 7.5 5S4.2 5.5 3 6.3v13c1.2-.8 2.8-1.3 4.5-1.3s3.3.5 4.5 1.3m0-13A8.2 8.2 0 0 1 16.5 5c1.7 0 3.3.5 4.5 1.3v13a8.2 8.2 0 0 0-4.5-1.3c-1.7 0-3.3.5-4.5 1.3"
})));

/* harmony default export */ var book = (SvgBook);
// EXTERNAL MODULE: ./images/social/discord.svg
var discord = __webpack_require__(6771);
;// CONCATENATED MODULE: ./images/social/mail.svg
var mail_path;

function mail_extends() { mail_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }



const SvgMail = props => /*#__PURE__*/react.createElement("svg", mail_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "w-6 h-6",
  viewBox: "0 0 24 24"
}, props), mail_path || (mail_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.98l7.5-4.04a2.25 2.25 0 0 1 2.134 0l7.5 4.04a2.25 2.25 0 0 1 1.183 1.98V19.5z"
})));

/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ./components/molecules/PromoWidget.tsx







const PromoWidget = /*#__PURE__*/ (0,react.memo)(()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* Widget */.$, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex flex-col justify-between pt-2 gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "ml-0 pl-0 text-gray-700 text-lg font-semibold transition-colors",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: "hover:text-green-700",
                        href: "/wspolpraca",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(book, {
                                className: "inline-block mr-2 -mt-1 w-8 stroke-current"
                            }),
                            "Moja książka:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "whitespace-nowrap",
                                children: "„TypeScript na poważnie”"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "ml-0 pl-0 text-gray-700 text-lg font-semibold transition-colors",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: "hover:text-green-700",
                        href: "https://discord.typeofweb.com/",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(discord/* default */.Z, {
                                className: "inline-block mr-2 -mt-1 w-8 stroke-current"
                            }),
                            "Discord"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "ml-0 pl-0 text-gray-700 text-lg font-semibold transition-colors",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: "hover:text-green-700",
                        href: "https://news.typeofweb.com/",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mail, {
                                className: "inline-block mr-2 -mt-1 w-8 stroke-current"
                            }),
                            "Newsletter"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "ml-0 pl-0 text-gray-700 text-lg font-semibold transition-colors",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "hover:text-green-700",
                        href: "https://www.next13masters.pl/?utm_source=typeofweb&utm_medium=sidebar",
                        children: "Już wkr\xf3tce odpalamy zapisy na drugą edycję next13masters.pl. Zapisz się na listę oczekujących!"
                    })
                })
            ]
        })
    });
});
PromoWidget.displayName = "PromoWidget";

// EXTERNAL MODULE: ./hooks/usePermalink.tsx
var usePermalink = __webpack_require__(8524);
;// CONCATENATED MODULE: ./components/molecules/SeriesTableOfContentsWidget.tsx






const SeriesTableOfContentsWidget = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { series  } = param;
    const permalink = (0,usePermalink/* usePermalink */.z)();
    const currentIndex = permalink ? (0,utils_series/* findCurrentSeriesIndex */.fZ)(permalink, series.links) : -1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* Widget */.$, {
        title: `Wpisy z serii ${series.name}:`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "counter-reset pl-10",
            children: series.links.map((link, idx)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "counter-increment before:counter-result before:text-stroke digits before:absolute relative before:top-0 before:-ml-12 mb-6 before:mr-2 before:text-gray-500 before:font-sans before:text-4xl before:proportional-nums before:font-semibold before:leading-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: `align-top hover:text-blue-500 text-gray-700 text-lg leading-snug transition-all ${currentIndex === idx ? "font-bold" : ""}`,
                            ...currentIndex === idx && {
                                rel: "bookmark"
                            },
                            href: "/" + link.permalink,
                            children: link.title
                        })
                    })
                }, link.permalink);
            })
        })
    });
});
SeriesTableOfContentsWidget.displayName = "SeriesTableOfContentsWidget";

// EXTERNAL MODULE: ./components/molecules/SocialWidget.tsx + 7 modules
var SocialWidget = __webpack_require__(8467);
;// CONCATENATED MODULE: ./components/organisms/Sidebar.tsx







const SearchWidget = dynamic_default()(()=>Promise.all(/* import() | SearchWidget */[__webpack_require__.e(481), __webpack_require__.e(429)]).then(__webpack_require__.bind(__webpack_require__, 9295)).then((m)=>m.SearchWidget), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9295)
            ]
    },
    ssr: false,
    loading () {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-12 bg-white rounded-lg shadow-md"
        });
    }
});
const searchClasses = `lg:min-w-[294px] border rounded-lg lg:w-full fixed z-50 right-3 top-0 lg:static lg:z-auto lg:flex-1 lg:shrink-0`;
const widgetClasses = `min-w-[294px] border rounded-lg flex-1 shrink-0`;
const widgetsPerPage = {
    index () {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: searchClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialWidget/* SocialWidget */.tZ, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestPostsWidget, {})
                })
            ]
        });
    },
    post (param) {
        let { series  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: searchClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWidget, {})
                }),
                series ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeriesTableOfContentsWidget, {
                        series: series
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: widgetClasses,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoWidget, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: widgetClasses,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialWidget/* SocialWidget */.tZ, {})
                        })
                    ]
                })
            ]
        });
    },
    page () {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: searchClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialWidget/* SocialWidget */.tZ, {})
                })
            ]
        });
    },
    category () {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: searchClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoWidget, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialWidget/* SocialWidget */.tZ, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestPostsWidget, {})
                })
            ]
        });
    },
    series (param) {
        let { series  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: searchClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWidget, {})
                }),
                series ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: widgetClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeriesTableOfContentsWidget, {
                        series: series
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: widgetClasses,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoWidget, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: widgetClasses,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialWidget/* SocialWidget */.tZ, {})
                        })
                    ]
                })
            ]
        });
    }
};
const Sidebar = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { pageKind , series  } = param;
    const Widgets = widgetsPerPage[pageKind];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        role: "complementary",
        className: "flex flex-row flex-wrap gap-8 px-2 w-full max-h-screen overflow-x-hidden overflow-y-scroll lg:sticky lg:top-20 lg:flex-col lg:flex-nowrap lg:mt-0 lg:mx-4 lg:pb-24 lg:pt-4 lg:max-w-xs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widgets, {
            pageKind: pageKind,
            series: series
        })
    });
});
Sidebar.displayName = "Sidebar";

// EXTERNAL MODULE: ./components/templates/hamburger.module.css
var hamburger_module = __webpack_require__(393);
var hamburger_module_default = /*#__PURE__*/__webpack_require__.n(hamburger_module);
;// CONCATENATED MODULE: ./components/templates/TwoColumns.tsx








const ShareWidget = dynamic_default()(()=>__webpack_require__.e(/* import() | ShareWidget */ 545).then(__webpack_require__.bind(__webpack_require__, 9910)).then((m)=>m.ShareWidget), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9910)
            ]
    },
    ssr: false
});
const TwoColumns = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { children , withSidebar , pageKind , series  } = param;
    const { setUIState , uiState  } = (0,useUiState/* useUIState */.J)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHeader/* SiteHeader */.H, {
                pageKind: pageKind
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-24 md:mt-12 flex flex-col items-center lg:flex-row lg:items-start lg:justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        itemScope: true,
                        itemType: "http://schema.org/Blog",
                        id: "main-content",
                        className: "relative flex-1 px-2 w-full max-w-3xl lg:pb-20 lg:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareWidget, {}),
                            children
                        ]
                    }),
                    withSidebar && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {
                        pageKind: pageKind,
                        series: series
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                id: "main-menu-button",
                "aria-expanded": uiState.isMenuOpen,
                "aria-controls": "main-menu",
                className: "main-menu-button no-touch-highlight fixed z-50 bottom-8 right-6 flex items-center justify-center w-12 h-12 text-gray-800 bg-white border border-solid border-gray-200 rounded-md shadow-lg select-none lg:hidden",
                onClick: ()=>setUIState((state)=>({
                            ...state,
                            isMenuOpen: !state.isMenuOpen
                        })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Otw\xf3rz nawigację"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        className: `${(hamburger_module_default()).ham} ${uiState.isMenuOpen ? (hamburger_module_default()).active : ""}`,
                        viewBox: "0 0 100 100",
                        width: "80",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: `${(hamburger_module_default()).line} ${(hamburger_module_default()).top}`,
                                d: "m 70,33 h -40 c -11.092231,0 11.883874,13.496726 -3.420361,12.956839 -0.962502,-2.089471 -2.222071,-3.282996 -4.545687,-3.282996 -2.323616,0 -5.113897,2.622752 -5.113897,7.071068 0,4.448316 2.080609,7.007933 5.555839,7.007933 2.401943,0 2.96769,-1.283974 4.166879,-3.282995 2.209342,0.273823 4.031294,1.642466 5.857227,-0.252538 v -13.005715 16.288404 h 7.653568"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: `${(hamburger_module_default()).line} ${(hamburger_module_default()).middle}`,
                                d: "m 70,50 h -40 c -5.6862,0 -8.534259,5.373483 -8.534259,11.551069 0,7.187738 3.499166,10.922274 13.131984,10.922274 11.021777,0 7.022787,-15.773343 15.531095,-15.773343 3.268142,0 5.177031,-2.159429 5.177031,-6.7 0,-4.540571 -1.766442,-7.33533 -5.087851,-7.326157 -3.321409,0.0092 -5.771288,2.789632 -5.771288,7.326157 0,4.536525 2.478983,6.805271 5.771288,6.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: `${(hamburger_module_default()).line} ${(hamburger_module_default()).bottom}`,
                                d: "m 70,67 h -40 c 0,0 -3.680675,0.737051 -3.660714,-3.517857 0.02541,-5.415597 3.391687,-10.357143 10.982142,-10.357143 4.048418,0 17.88928,0.178572 23.482143,0.178572 0,2.563604 2.451177,3.403635 4.642857,3.392857 2.19168,-0.01078 4.373905,-1.369814 4.375,-3.392857 0.0011,-2.023043 -1.924401,-2.589191 -4.553571,-4.107143 -2.62917,-1.517952 -4.196429,-1.799562 -4.196429,-3.660714 0,-1.861153 2.442181,-3.118811 4.196429,-3.035715 1.754248,0.0831 4.375,0.890841 4.375,3.125 2.628634,0 6.160714,0.267857 6.160714,0.267857 l -0.178571,-2.946428 10.178571,0 -10.178571,0 v 6.696428 l 8.928571,0 -8.928571,0 v 7.142858 l 10.178571,0 -10.178571,0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter/* AppFooter */.q, {})
        ]
    });
});
TwoColumns.displayName = "TwoColumns";


/***/ }),

/***/ 2595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/atoms/Pagination.tsx




const Pagination = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { prefix , pages  } = param;
    const router = (0,next_router.useRouter)();
    const currentPage = Number(router.query["page"]) || 1;
    const next = currentPage + 1;
    const prev = currentPage - 1;
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const goToPage = (0,react.useCallback)((e)=>{
        const page = Number(e.currentTarget.value);
        const href = `${prefix}/strona/${page}`;
        setIsLoading(true);
        router.push(href, undefined, {
            scroll: true
        }).finally(()=>setIsLoading(false));
    }, [
        prefix,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: `flex flex-col gap-4 items-center mb-4 ${isLoading ? "cursor-wait" : ""}`,
        role: "navigation",
        "aria-label": "Paginacja",
        "aria-busy": isLoading,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "items-center mr-2 text-gray-900 text-lg",
                children: [
                    "Strona ",
                    currentPage,
                    " z ",
                    pages
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-2 items-stretch justify-center pb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: `${prefix}/strona/${prev}`,
                        rel: "prev",
                        className: `focus:no-underline gap-3 inline-flex items-center px-4 py-2 bg-gray-200 border rounded-md shadow-sm hover:shadow-md transition-shadow ${isLoading ? "cursor-wait pointer-events-none text-gray-500" : "text-gray-900"}
            ${prev > 0 ? "" : "invisible"}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "w-6 rotate-180",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            }),
                            "Poprzednia strona"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        className: `m-0 bg-gray-100 text-gray-900 text-lg border-transparent rounded-sm hover:shadow-md shadow-sm transition-shadow ${isLoading ? "cursor-wait pointer-events-none" : ""}`,
                        disabled: isLoading || pages === 1,
                        "aria-label": "Wybierz stronę",
                        title: "Wybierz stronę",
                        value: currentPage,
                        onChange: goToPage,
                        children: [
                            ...Array(pages)
                        ].map((_, idx)=>{
                            const page = idx + 1;
                            const isCurrent = currentPage === page;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: page,
                                "aria-label": isCurrent ? `Obecna strona, strona ${page}` : `Strona ${page}`,
                                "aria-current": isCurrent ? "page" : false,
                                disabled: isCurrent,
                                children: page
                            }, page);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: `${prefix}/strona/${next}`,
                        rel: "next",
                        className: `focus:no-underline gap-3 inline-flex items-center px-4 py-2 bg-gray-200 border rounded-md shadow-sm hover:shadow-md transition-shadow ${isLoading ? "cursor-wait pointer-events-none text-gray-500" : "text-gray-900"}
              ${next <= pages ? "" : "invisible"}`,
                        children: [
                            "Następna strona",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "w-6",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Pagination.displayName = "Pagination";

// EXTERNAL MODULE: ./components/molecules/NewsletterForm.tsx + 1 modules
var NewsletterForm = __webpack_require__(8958);
// EXTERNAL MODULE: ./utils/permalinks.ts
var permalinks = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/ArticleCoverImage.tsx
var ArticleCoverImage = __webpack_require__(9655);
// EXTERNAL MODULE: ./components/atoms/ArticleTitle.tsx
var ArticleTitle = __webpack_require__(2298);
// EXTERNAL MODULE: ./components/atoms/Card.tsx
var Card = __webpack_require__(2409);
// EXTERNAL MODULE: ./components/atoms/LinkUnderlineEffect.tsx
var LinkUnderlineEffect = __webpack_require__(8683);
// EXTERNAL MODULE: ./components/molecules/ArticleMeta.tsx
var ArticleMeta = __webpack_require__(1244);
;// CONCATENATED MODULE: ./components/organisms/ArticleSneakPeek.tsx









const ArticleSneakPeek = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { cover , title , authors , mainCategory , permalink , series , excerpt , commentsCount  } = param;
    const href = (0,permalinks/* getUrlForPermalink */.U)(permalink);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        as: "article",
        itemScope: true,
        itemType: "http://schema.org/BlogPosting",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `px-7 sm:px-8 lg:px-12 bg-gray-100 py-4`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTitle/* ArticleTitle */.j, {
                            title: title,
                            href: href,
                            level: 2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleMeta/* ArticleMeta */.q, {
                            series: series,
                            authors: authors,
                            mainCategory: mainCategory,
                            commentsCount: commentsCount,
                            permalink: permalink,
                            size: "small"
                        }),
                        cover && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: href,
                            tabIndex: -1,
                            "aria-hidden": "true",
                            className: "block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCoverImage/* ArticleCoverImage */.p, {
                                cover: cover
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-12 px-7 text-gray-900 font-serif text-lg border-b-2 sm:px-8 lg:px-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "!indent-0",
                    children: [
                        excerpt,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: href,
                                    className: "text-blue-500 font-bold tracking-wider",
                                    children: [
                                        "Czytaj dalej… ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "sr-only",
                                            children: [
                                                "artykuł ",
                                                title
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                itemProp: "publisher",
                itemScope: true,
                itemType: "https://schema.org/Organization",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "logo",
                        itemScope: true,
                        itemType: "https://schema.org/ImageObject",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            itemProp: "url",
                            content: "/wp-content/uploads/2020/04/logo_kwadrat11.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "name",
                        content: "Type of Web"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                itemProp: "mainEntityOfPage",
                href: href
            })
        ]
    });
});
ArticleSneakPeek.displayName = "ArticleSneakPeek";

;// CONCATENATED MODULE: ./images/youtube-logo.svg
var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgYoutubeLogo = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 889 201"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "#282828"
}, /*#__PURE__*/react.createElement("path", {
  fill: "red",
  d: "M83 2.7c-18.3.8-40.3 2.6-46.7 3.8a38.6 38.6 0 0 0-21.1 10.6C7.3 25.2 4.5 34.2 1.9 61a667.3 667.3 0 0 0 0 80c2.6 26.8 5.4 35.8 13.3 43.9 12.1 12.2 25.5 14 111.8 14.8 70.7.7 112.7-1.2 127.2-5.7a35.4 35.4 0 0 0 22.8-21.7c5.6-14.7 8.4-62.6 6-100.8-2.4-37.3-6.2-49.3-18.2-58.1C255.9 6.8 245.7 5 208 3c-17.1-.9-107.3-1.1-125-.3zM151.4 80a981.3 981.3 0 0 1 35.6 21c0 .5-70 41.1-72.1 41.8-.5.2-.9-16.7-.9-41.8 0-25.1.4-42 .9-41.8.5.1 16.9 9.5 36.5 20.8z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M722 97.5V186h24.7l1.2-5.6 1.3-5.6 1.8 2.7c4 6 13.3 10.5 22 10.5 13.2 0 20.7-6.9 25.6-23.6 2.5-8.8 3.3-65 1-78.3-3.6-20.8-11-28.1-27.1-26.8-7.5.6-12.9 3.2-18.3 9.1L750 73V9h-28v88.5zm45.4-15.2c3.9 3.9 4.8 13.1 4.4 44.9-.3 26.5-.4 28.6-2.5 33-1.1 2.5-3 5.1-4.1 5.7-4.4 2.3-10.4.7-13.9-3.9-.9-1.1-1.2-10.4-1.3-35.8 0-37.6.1-38.6 5.9-43.5 4.1-3.4 8.4-3.5 11.5-.4zM311 16.3l16 58.1 16 57.8V186h28v-54.3l15.4-55.1 16.2-57.9.6-2.7h-28.7l-6.3 28.7c-3.5 15.9-7.3 34.1-8.5 40.5A71.5 71.5 0 0 1 357 97a24 24 0 0 1-1.8-7.3c-.7-3.9-4.4-21.9-8.2-39.8-3.9-17.9-7-32.9-7-33.2a219 219 0 0 0-29-.4zm245 11.2V39h27v147h29V39h27V16h-83v11.5zM421.1 60.6c-20.6 5.5-27.1 23.5-25.8 71.3 1 34.4 5.2 45.8 19.5 52.8 5.4 2.6 6.4 2.8 19.2 2.8 12.1 0 14.1-.3 18.8-2.4a31.3 31.3 0 0 0 16.1-18.4c3.6-11.1 4.3-19.4 3.8-48.1-.3-23.3-.7-28-2.4-33.7-4-13.5-10.2-20.5-21.2-23.9-7.6-2.4-20-2.6-28-.4zm18.3 20.7c3.9 3.9 4.6 10.5 4.6 43.1 0 31.6-.6 37.3-4.6 41.7-2.3 2.5-7.8 2.5-10.3 0-4-4-4.5-9.1-4.5-42.1 0-33.8.5-38.2 4.9-42.6 3-3 6.9-3.1 9.9-.1zM838 60.5c-13.7 3.9-20.3 12.7-23.6 31.6-2.2 13.1-1.5 60.4 1 69.3 3.7 12.7 9 19.6 18.1 23.8 4.3 1.9 6.7 2.3 16.5 2.3 6.5 0 13.3-.6 15.7-1.3 12.4-3.7 19.9-14.1 21-28.9.5-6.6.3-8.3-.8-8.7-.8-.2-6.4-.7-12.6-.9l-11.2-.6-.6 4.7c-1.6 12.7-3.9 16.2-10.5 16.2-7.3 0-10-6.9-10-25.3V134h47.3l-.6-20.3c-.3-11.1-1.1-23.1-1.7-26.7-2.2-13.1-8.7-22.3-17.8-25.5a71.5 71.5 0 0 0-30.2-1zm17.7 20c3 2.1 4.3 8.8 4.3 22.9V116h-19.3l.5-14.3c.6-14.4 1.6-19.2 4.5-21.5 2.3-1.6 7.4-1.5 10 .3z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M487 112c0 33.8.4 52.7 1.1 56.2 2.9 13.8 10 19.8 23.2 19.8 10.5 0 18.7-4 23.9-11.5 1.2-1.9 2.6-3.5 2.9-3.5.3 0 1 2.8 1.5 6.2l.9 6.3 11.3.3 11.2.3V61h-28v49.4c0 49.1 0 49.3-2.2 52.1-5 6.4-13.5 6.6-15.7.3-.7-2-1.1-20.1-1.1-52.4V61h-29v51zm143.2 2.7c.3 53.2.3 53.9 2.6 59.4 3.9 9.7 10.4 13.9 21.5 13.9 10.8 0 18.6-3.9 24.3-12.2l2.9-4.2 1 7 1 6.9 11.8.3 11.7.3V61h-29v98.8l-2.5 3.1a16.4 16.4 0 0 1-6.1 4.1c-3.2 1.1-4 1-6.2-.7a9.5 9.5 0 0 1-3.3-4.4c-.4-1.3-.7-24.6-.8-51.7L659 61h-29.1l.3 53.7z"
}))));

/* harmony default export */ var youtube_logo = (SvgYoutubeLogo);
// EXTERNAL MODULE: ./components/atoms/SectionTitle.tsx
var SectionTitle = __webpack_require__(3895);
;// CONCATENATED MODULE: ./components/organisms/VideoSneakPeek.tsx








const VideoSneakPeek = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { video  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        as: "article",
        className: "pt-4",
        itemScope: true,
        itemType: "http://schema.org/Video",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `px-7 sm:px-8 lg:px-12 bg-gray-100 pb-9 flex flex-row items-start sm:items-center`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-2 flex items-center mt-1.5 sm:mt-0 relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: video.url,
                                target: "_blank",
                                className: "inline-block",
                                itemProp: "mainEntityOfPage",
                                rel: "bookmark noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                    size: "medium",
                                    level: 2,
                                    itemProp: "headline",
                                    children: (0,ArticleTitle/* wisząceSpójniki */.r)(video.title)
                                })
                            })
                        }),
                        video.cover && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "order-1 w-full ml-6 mr-10 -mt-2 lg:-mt-6 relative basis-16 sm:basis-36 shrink-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: video.url,
                                    target: "_blank",
                                    tabIndex: -1,
                                    "aria-hidden": "true",
                                    className: "block",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCoverImage/* ArticleCoverImage */.p, {
                                        cover: {
                                            blurDataURL: video.cover.blurDataURL,
                                            img: video.cover.img,
                                            preload: true
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex -ml-6 absolute left-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: video.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_logo, {
                                            className: "h-5"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-12 px-7 text-gray-900 font-serif text-lg border-b-2 sm:px-8 lg:px-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "!indent-0 whitespace-pre-line",
                    children: [
                        video.description,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: video.url,
                                    target: "_blank",
                                    className: "text-blue-500 font-bold tracking-wider",
                                    rel: "noreferrer",
                                    children: [
                                        "Obejrzyj na YouTube ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "sr-only",
                                            children: [
                                                "filmik ",
                                                video.title
                                            ]
                                        }),
                                        "…"
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                itemProp: "publisher",
                itemScope: true,
                itemType: "https://schema.org/Organization",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "logo",
                        itemScope: true,
                        itemType: "https://schema.org/ImageObject",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            itemProp: "url",
                            content: "/wp-content/uploads/2020/04/logo_kwadrat11.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "name",
                        content: "Type of Web"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                itemProp: "mainEntityOfPage",
                href: video.url
            })
        ]
    });
});
VideoSneakPeek.displayName = "VideoSneakPeek";

// EXTERNAL MODULE: ./components/templates/TwoColumns.tsx + 6 modules
var TwoColumns = __webpack_require__(7686);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
;// CONCATENATED MODULE: ./pages/index.tsx









const IndexPage = (param)=>{
    let { posts , videos , postsCount , permalink , pageKind , seriesLinks  } = param;
    const href = permalink ? (0,permalinks/* getUrlForPermalink */.U)(permalink) : null;
    const items = [
        ...posts.map((post)=>({
                ...post,
                type: "post"
            })),
        ...(videos ?? []).map((video)=>({
                ...video,
                type: "video"
            }))
    ].sort((a, b)=>{
        const dateA = a.type === "post" ? a.frontmatter.date : a.date;
        const dateB = b.type === "post" ? b.frontmatter.date : b.date;
        return dateB.localeCompare(dateA);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoColumns/* TwoColumns */.V, {
        withSidebar: true,
        pageKind: pageKind,
        series: pageKind === "series" ? seriesLinks : null,
        children: [
            items.map((item, i)=>{
                const key = item.type === "post" ? item.frontmatter.title : item.title;
                const sneakPeek = item.type === "post" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PostIndexItem, {
                    pageKind: pageKind,
                    post: item,
                    i: i
                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoIndexItem, {
                    video: item
                }, key);
                if (i === 0) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            sneakPeek,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterForm.NewsletterForm, {})
                        ]
                    }, key);
                }
                return sneakPeek;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                pages: Math.ceil(postsCount / 10),
                prefix: href ? `${constants/* host */.ho}${href}` : constants/* host */.ho
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);
const VideoIndexItem = (param)=>{
    let { video  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSneakPeek, {
        video: video
    });
};
const PostIndexItem = (param)=>{
    let { post , pageKind , i  } = param;
    if (!post.excerpt) {
        console.warn(`Missing excerpt for post ${post.frontmatter.permalink}!`);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSneakPeek, {
        title: post.frontmatter.title,
        mainCategory: post.frontmatter.mainCategory,
        permalink: post.frontmatter.permalink,
        authors: post.frontmatter.authors,
        cover: post.frontmatter.cover ? {
            ...post.frontmatter.cover,
            preload: i === 0
        } : null,
        index: pageKind === "index" ? post.frontmatter.index : null,
        excerpt: post.excerpt,
        series: post.frontmatter.series,
        commentsCount: post.frontmatter.commentsCount
    });
};


/***/ }),

/***/ 393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ham":"hamburger_ham__dOHse","top":"hamburger_top__pZrL6","middle":"hamburger_middle__ctZRB","bottom":"hamburger_bottom__S_XrR","active":"hamburger_active__eQYEK","line":"hamburger_line__WZMbn"};

/***/ })

}]);